import React from 'react';
import classNames from 'classnames';
import { Icon } from '@beisen/chaos-ui';
import transLoader from '@beisen/i18n-translation-loader';
require('./TableTitle.scss');

const defaultTranslation = {
    more: '更多'
};
class TableTitle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lineHeight: false
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            more: 'common.more'
        }), props.translation);

    }
    componentDidMount() {
        if (window.env.platform.ios) {
            this.setState({ lineHeight: true });
        }
    }

    render() {
        const { tableTitle, loadmore, touchTapMore } = this.props;
        return (<div className='table-title-padding'>
                    <div className='table-title-box'>
                        <span className='table-title-tag table-position' />
                        <span className={classNames('table-title','table-position', { 'table-line-height': this.state.lineHeight },{ 'loadmore': loadmore })} >{tableTitle}</span>
                        {loadmore ? <span className={classNames('table-title-load-more','table-position', { 'table-line-height': this.state.lineHeight })} onTouchTap={touchTapMore}>{this.translation.more}</span> : null}
                        {loadmore ? <Icon className='table-position' icon='m-sys-forward' /> : null}
                        {loadmore ? <span className='table-title-space'></span> : null}
                    </div>
                </div>);
    }
}

export default TableTitle;



// WEBPACK FOOTER //
// ./src/components/Table_Components/TableTitle/TableTitle.js